import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
interface DescriptionProps {
    description: string;
}

const Description: React.FunctionComponent<DescriptionProps> = ({ description }) => {
    const data = JSON.parse(description);
    const { t } = useTranslation();

    return (
        <>
            {data.startingPosition && (
                <>
                    <Typography fontWeight={700}>{t("starting_position")}</Typography>
                    <ul>
                        {data.startingPosition.map((item: string, index: number) => (
                            <li key={`startingPosition${index}`}>{item}</li>
                        ))}
                    </ul>
                </>
            )}
            <Typography fontWeight={700}>{t("execution")}</Typography>
            <ul>{data.execution && data.execution.map((item: string, index: number) => <li key={`execution${index}`}>{item}</li>)}</ul>
            {data.attention && (
                <>
                    <Typography fontWeight={700}>{t("attention")}</Typography>
                    <ul>
                        {data.attention.map((item: string, index: number) => (
                            <li key={`attention${index}`}>{item}</li>
                        ))}
                    </ul>
                </>
            )}
            {data.variation && (
                <>
                    <Typography fontWeight={700}>{t("variation")}</Typography>
                    <ul>
                        {data.variation.map((item: string, index: number) => (
                            <li key={`variation${index}`}>{item}</li>
                        ))}
                    </ul>
                </>
            )}
        </>
    );
};

export default Description;
